import { gql } from '@apollo/client';
import { RISK_FIELDS } from 'domain/shared/newProject/graphql/risksFragments';

export const GET_PROJECT_RISKS = gql`
  query GetProjectRisks($id: ID!) {
    baseProject(id: $id) {
      id
      risks {
        ${RISK_FIELDS}
      }
    }
  }
`;

export const GET_PROJECT_WITH_RISK = gql`
  query GetProjectWithRisk($projectId: ID!) {
    baseProject(id: $projectId) {
      id
      name
      risks {
        id
        alias
        title
        description
        type
        status
        probability
        severity
        totalScore
        projectId
        riskOwner
        mitigationStrategy
        isEscalated
        isIncludedInCustomerReport
        resolvedAt
        resolveComment
        timeline {
          id
          text
          type
          attachmentPaths
          isPinned
          createdBy
          createdAt
          updatedBy
          updatedAt
        }
        createdBy
        createdAt
        updatedBy
        updatedAt
        deletedAt
        deletedBy
      }
      accessInfo {
        id
        sections {
          section
          allowedActions
        }
      }
    }
  }
`;

export const GET_PROJECT_ACCOUNT_OWNER = gql`
  query GetProjectAccountOwner($projectId: ID!) {
    baseProject(id: $projectId) {
      id
      accountData {
        ownerAlias
      }
    }
  }
`;
